export class Costcenter {
	costcenterid: number;
	costcentername: string;
	remarks: string;
	poreviewerid: number;
	poapproverid: number;
	poapproveridlevel1:number;
	polevel1amount:number;
	active: number;	
    createon: Date;
	createdby:number;	
    modifiedon: Date;	
	modifiedby: number;
	isActive: number
	approvername: string;
	reviewername: string;
}